const React = require('react');
const WeeklyLeaders = require('components/Gamification/WeeklyLeaders');
const T = require('prop-types');
const { default: Styled } = require('styled-components');
const { transient$Props } = require('utils/styles');

const { useDispatch } = require('react-redux');
const { Link, Prompt } = require('react-router-dom');

const { default: AppBar } = require('@mui/material/AppBar');
const { default: Toolbar } = require('@mui/material/Toolbar');
const { default: Paper } = require('@mui/material/Paper');
const { default: Dialog } = require('@mui/material/Dialog');
const { default: DialogTitle } = require('@mui/material/DialogTitle');
const { default: DialogContent } = require('@mui/material/DialogContent');
const { default: DialogContentText } = require('@mui/material/DialogContentText');
const { default: DialogActions } = require('@mui/material/DialogActions');
const { default: Button } = require('@mui/material/Button');
const { default: IconButton } = require('@mui/material/IconButton');
const { default: ImportExportIcon } = require('@mui/icons-material/ImportExport');
const { default: ArrowRightAltIcon } = require('@mui/icons-material/ArrowRightAlt');
const { default: Typography } = require('@mui/material/Typography');
const { default: Backdrop } = require('@mui/material/Backdrop');

const { default: Tooltip } = require('@mui/material/Tooltip');

const { default: MenuIcon } = require('@mui/icons-material/Menu');

const Snackbar = require('containers/Snackbar');

const MuiAppMenu = require('components/AppMenu');
const LoadingScreen = require('components/LoadingScreen');
const FocusIndicator = require('components/FocusIndicator');
const OfflineIndicator = require('components/OfflineIndicator');
const DowntimeDialog = require('containers/DowntimeDialog');
const ForceAppUpgradeDialog = require('containers/ForceAppUpgradeDialog');
const SimpleDialog = require('components/SimpleDialog');
const TooltipIconAnchor = require('components/TooltipIconAnchor');
const NearpeerNLogo = require('static/nearpeer_n_white.svg');
const NearpeerLogo = require('static/nearpeer_logo_white.svg');
const NearpeerWordmark = require('static/nearpeer_wordmark_white.svg');
const UnreadMessagesBadge = require('routes/app/components/UnreadMessagesBadge');

const GetQueryParams = require('utils/get-query-params');
const { analyticsTemplates } = require('utils/analytics');
const { useAppSelector } = require('utils/redux');
const { getSvgDataUrl, getSchoolTileImageSrc } = require('utils/image');
const PageTitleByPath = require('utils/pageTitleByPath');

const {
    ELEMENT_IDS,
    MAIN_HEADER_HEIGHT,
    DIALOG_SCHOOL_IMG_HEIGHT,
    USER_ROLE_IDS
} = require('utils/constants');

const Fonts = require('styles/fonts.json');

const { useSsoAuth } = require('hooks/useSsoAuth');

const { RolePermissions } = require('schema/user');
const { context } = require('app-context');

const { default: Classes } = require('./styles.scss');

const NotificationsDialog = require('../../routes/app/containers/NotificationsDialog');
const NotificationsButton = require('../../routes/app/containers/NotificationsButton');
const AppFooterTabs = require('../components/AppFooterTabs');

const {
    getDevice,
    isIOS: getIsIOS,
    isAndroid: getIsAndroid
} = require('utils/device');

const {
    actions,
    selectors: { all: selectors }
} = context;

const {
    useState,
    useRef,
    useEffect
} = React;

const isCordovaApp = !!window.cordova;

const InAppBrowser = isCordovaApp ? window.cordova.InAppBrowser : null;

const internals = {};


module.exports = function AppLayout(props) {

    const {
        numUnreadNotifications,
        openNotifications,
        closeNotifications,
        closeLogoutDialog,
        onLogout,
        openLogoutDialog,
        currentUser,
        rootSchool,
        canJoinNearpeerCommunity,
        switchableCommunities,
        joinableCommunities,
        currentSchool,
        notificationsOpen,
        otherCommunityUnreadCounts,
        unreadOffersCount,
        hasOffers,
        isLoadingOffers,
        unreadResourcesCount,
        hasResources,
        isLoadingResources,
        modalOpen,
        location,
        logoutDialogOpen,
        role,
        rolePermissions,
        schoolSlug,
        appHeaderLogoUrl,
        hasResourcesPage,
        resourcesUrl,
        rootLoading,
        isSSOSchool,
        path,
        navigate,
        isOffline,
        isCommunity,
        children,
        fullWidthMobileRoutes,
        isReviewEnabled,
        nearpeerSchool,
        debug,
        setDebug
    } = props;

    const {
        Wrapper,
        SkipToContentLink,
        StyledAppBar,
        Header,
        StyledAppMenu,
        styles,
        MaxWidth,
        HeaderStart,
        TitleArea,
        LogoContainer,
        LogoutConfirmButton,
        WhiteMenuIcon,
        MainInnerWrapper,
        StyledIconButton,
        ScrollContainer,
        HiddenPageHeading,
        NearpeerNSwitchButtonWrapper,
        ManageCommunitiesLinkWrapper,
        StyledImportExportIcon,
        StyledUnreadMessagesBadge
        // StyledBackdrop,
        // SpinnerContainer
    } = internals;

    const [displayStatus, setDisplayStatus] = useState(false);
    const [isReviewDialogOpen, setIsReviewDialogOpen] = useState(false);
    const switchingSchoolText = useAppSelector(selectors.getSwitchingSchoolText);
    const dispatch = useDispatch();

    const [isNearpeerSwitcherDialogOpen, setIsNearpeerSwitcherDialogOpen] = useState(false);
    const [isConfirmProfileDialogOpen, setIsConfirmProfileDialogOpen] = useState(false);

    const logoutContentsRef = useRef();

    useEffect(() => {

        setDisplayStatus(numUnreadNotifications > 0);
    }, [numUnreadNotifications]);

    const logout = () => {

        openLogoutDialog();

        setTimeout(() => {

            logoutContentsRef.current?.focus();
        }, 100);
    };

    const _openNotifications = () => {

        setDisplayStatus(false);

        analyticsTemplates.navigationWithVal(
            'viewed notifications',
            'main: viewed notifications',
            numUnreadNotifications
        );

        openNotifications();
    };

    const handleConfirmPageClick = (e) => {

        if (e) {
            e.preventDefault();
        }

        setIsConfirmProfileDialogOpen(true);
    };

    const closeConfirmProfileDialog = () => {

        setIsConfirmProfileDialogOpen(false);
    };

    const focusMainContent = (event) => {

        event?.preventDefault();

        const mainContent = document.getElementById('main-content');

        if (!mainContent) {
            return;
        }

        mainContent.focus();
        mainContent.scrollIntoView({
            block: 'start'
        });
    };


    const device = getDevice();
    const isIOS = getIsIOS(device);
    const isAndroid = getIsAndroid(device);
    const isMobile = isIOS || isAndroid;
    const isTeamsApp = process.env.APP_FLAVOUR === 'teams';

    const handleLeaveReview = () => {

        setIsReviewDialogOpen(true);
    };


    const closeReviewDialog = () => {

        FocusIndicator.onBlurHandler();
        setIsReviewDialogOpen(false);
    };

    const confirmLeaveReview = () => {

        analyticsTemplates.buttons('click main menu item', 'main: confirm leave a review');

        let appStoreUrl;

        closeReviewDialog();

        if (isIOS) {
            appStoreUrl = isTeamsApp
                ? 'https://itunes.apple.com/us/app/nearpeer-for-teams/id6445984458?action=write-review'
                : 'https://itunes.apple.com/us/app/nearpeer-for-college-students/id1300243604?action=write-review';
        }
        else if (isAndroid) {
            appStoreUrl = isTeamsApp
                ? 'https://play.google.com/store/apps/details?id=net.nearpeer.app_business&reviewId=0'
                : 'https://play.google.com/store/apps/details?id=net.nearpeer.app&reviewId=0';
        }

        if (appStoreUrl) {
            if (isCordovaApp && InAppBrowser) {
                InAppBrowser.open(appStoreUrl, '_system');
            }
            else {
                window.open(appStoreUrl, '_blank');
            }
        }
    };


    const _closeLogoutDialog = () => {

        closeLogoutDialog();
        FocusIndicator.onBlurHandler();
    };

    useEffect(() => {

        if (rootLoading || !currentUser || !currentSchool?.offersEnabled || !isLoadingOffers) {
            return;
        }

        dispatch(actions.dataFetching.fetchOffers());
    }, [currentSchool?.id, currentSchool?.offersEnabled, currentUser?.id, dispatch, isLoadingOffers, rootLoading]);

    useEffect(() => {

        const isProspect = USER_ROLE_IDS.PROSPECT.includes(currentUser?.roleId);

        if (rootLoading || !currentUser || !isProspect || !isLoadingResources) {
            return;
        }

        dispatch(actions.dataFetching.fetchResources());
    }, [currentUser?.id, currentUser?.roleId, dispatch, isLoadingResources, rootLoading]);

    if (rootLoading || !currentUser) {
        const loadingMessage = switchingSchoolText ? `Switching to ${switchingSchoolText}` : 'Logging in...';

        return <LoadingScreen variant='screen' message={loadingMessage} />;
    }


    const pathNoTrailingSlash = path.replace(/\/$/, '');
    const isEditProfile = (path.indexOf('/app/profile/edit') === 0) || (path.indexOf('/signup/user-info') === 0);
    const isFullWidthRoute = !!(fullWidthMobileRoutes.find((startsWith) => pathNoTrailingSlash.startsWith(startsWith)));
    const pageTitle = PageTitleByPath(pathNoTrailingSlash) || 'Nearpeer';


    const shouldShowCommunityManagement = !!switchableCommunities.length || !!joinableCommunities.length;

    const hasNewCommunityInvites = !!joinableCommunities.find(({ isNewInvite }) => isNewInvite);


    const switchSchool = (school) => {

        setIsNearpeerSwitcherDialogOpen(false);

        dispatch(actions.profileManagement.switchSchool({
            schoolId: school.id
        }));
    };

    const nearpeerSvgSrc = getSvgDataUrl(nearpeerSchool?.svg);
    const currentSchoolSvgSrc = getSchoolTileImageSrc(currentSchool);

    // TODO check if GetQueryParams() is being called too much.
    const { confirm: isConfirmPage } = GetQueryParams();
    const currentSchoolIsNearpeer = currentSchool.id === 1;
    const shouldEnableNearpeerHeaderBtn = !currentSchoolIsNearpeer && canJoinNearpeerCommunity;

    const otherCommunityUnreadCountsTotal = Object.values(otherCommunityUnreadCounts || {})
        .reduce((total, count) => {

            return total + count;
        }, 0);

    return (
        <WeeklyLeaders user={currentUser} schoolId={currentSchool?.id} path={path}>
        <Wrapper
            onFocus={FocusIndicator.onFocusHandler}
            onBlur={FocusIndicator.onBlurHandler}
        >
            <SkipToContentLink
                href='#main-content'
                onClick={focusMainContent}
            >
                Skip to content
            </SkipToContentLink>
            <React.Fragment>
                <Prompt when={logoutDialogOpen} message='Are you sure you want to log out?' />
                <Dialog
                    open={logoutDialogOpen}
                    onClose={_closeLogoutDialog}
                    aria-labelledby='alert-logout-dialog-title'
                    aria-describedby='alert-logout-dialog-description'
                >
                    <div
                        ref={logoutContentsRef}
                        tabIndex={0}
                        data-focus-outline='radius:15'
                    >
                        <DialogTitle id='alert-logout-dialog-title'>{'Log Out'}</DialogTitle>
                        <DialogContent>
                            <DialogContentText id='alert-logout-dialog-description'>
                                Are you sure you want to log out?
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                onClick={_closeLogoutDialog}
                                color='secondary'
                                variant='contained'
                                data-focus-outline='radius:40,padding:3'
                            >
                                No
                            </Button>
                            <LogoutConfirmButton
                                onClick={() => {

                                    _closeLogoutDialog();
                                    onLogout();
                                }}
                            />
                        </DialogActions>
                    </div>
                </Dialog>
            </React.Fragment>

            <Header>
                <OfflineIndicator isOffline={!!isOffline} />
                <Paper>
                    <div className='contentWrapper'>
                        <StyledAppBar elevation={0}>
                            <Toolbar style={{ height: '100%' }}>
                                <MaxWidth>
                                    <HeaderStart>
                                    <StyledAppMenu
                                        id='app-menu'
                                        Icon={<WhiteMenuIcon />}
                                        rootSchool={rootSchool}
                                        canJoinNearpeerCommunity={canJoinNearpeerCommunity}
                                        switchableCommunities={switchableCommunities}
                                        currentSchool={currentSchool}
                                        isConfirmPage={isConfirmPage}
                                        onConfirmPageClick={handleConfirmPageClick}
                                        push={navigate}
                                        switchSchool={switchSchool}
                                        otherCommunityUnreadCounts={otherCommunityUnreadCounts}
                                        currentUser={currentUser}
                                        role={role}
                                        rolePermissions={rolePermissions}
                                        joinableCommunities={joinableCommunities}
                                        schoolSlug={schoolSlug}
                                        hasResourcesPage={hasResourcesPage}
                                        resourcesUrl={resourcesUrl}
                                        isSSOSchool={isSSOSchool}
                                        isReviewEnabled={isReviewEnabled}
                                        onLeaveReview={handleLeaveReview}
                                        onLogout={logout}
                                        debug={debug}
                                        setDebug={setDebug}
                                        hasOffers={hasOffers}
                                    />
                                    {!currentSchoolIsNearpeer && (
                                        <NearpeerNSwitchButtonWrapper>
                                            <Tooltip
                                                arrow
                                                title={canJoinNearpeerCommunity && !isConfirmPage ? 'Switch to Nearpeer' : ''}
                                                placement='bottom'
                                            >
                                                <TooltipIconAnchor>
                                                    <button
                                                        disabled={!shouldEnableNearpeerHeaderBtn && !isConfirmPage}
                                                        aria-label="Switch to Nearpeer"
                                                        style={{
                                                            width: 36,
                                                            height: 36,
                                                            cursor: (shouldEnableNearpeerHeaderBtn || isConfirmPage) ? 'pointer' : 'default',
                                                            background: '#4611a9',
                                                            border: 'none',
                                                            padding: 0,
                                                            borderRadius: 5
                                                        }}
                                                        onClick={isConfirmPage ? handleConfirmPageClick : () => setIsNearpeerSwitcherDialogOpen(true)}
                                                    >
                                                        <img
                                                            src={NearpeerNLogo}
                                                            alt=""
                                                            style={{
                                                                padding: 5
                                                            }}
                                                        />
                                                    </button>
                                                </TooltipIconAnchor>
                                            </Tooltip>
                                        </NearpeerNSwitchButtonWrapper>
                                    )}

                                    </HeaderStart>
                                    {currentUser && (
                                        <TitleArea>
                                            <Link
                                                to='/app/welcome'
                                                data-focus-outline='radius:5,padding:8'
                                                onClick={isConfirmPage ? handleConfirmPageClick : undefined}
                                            >
                                                <LogoContainer $compactDefaultLogo={!currentSchool?.theme && appHeaderLogoUrl === NearpeerLogo}>
                                                    <img
                                                        src={!currentSchool?.theme && appHeaderLogoUrl === NearpeerLogo ? NearpeerWordmark : appHeaderLogoUrl}
                                                        alt='App logo'
                                                    />
                                                </LogoContainer>
                                            </Link>
                                        </TitleArea>
                                    )}

                                    {!modalOpen && (
                                        <div style={{
                                            display: 'flex',
                                            flexFlow: 'row nowrap',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}>
                                            {shouldShowCommunityManagement && (
                                                <ManageCommunitiesLinkWrapper>
                                                    <Tooltip
                                                        arrow
                                                        title={isConfirmPage ? '' : 'Manage Communities'}
                                                        placement='bottom'
                                                    >
                                                        <TooltipIconAnchor style={{
                                                            marginRight: isMobile ? -15 : -10
                                                        }}>
                                                            <StyledIconButton
                                                                as={Link}
                                                                to='/app/manage-communities'
                                                                aria-label='Manage Communities'
                                                                onClick={isConfirmPage ? handleConfirmPageClick : undefined}
                                                            >
                                                                <StyledImportExportIcon />
                                                            </StyledIconButton>
                                                        </TooltipIconAnchor>
                                                        <StyledUnreadMessagesBadge
                                                            numUnreads={hasNewCommunityInvites ? 'NEW' : otherCommunityUnreadCountsTotal}
                                                            style={{ 'pointer-events': 'none' }}
                                                        />
                                                    </Tooltip>
                                                </ManageCommunitiesLinkWrapper>
                                            )}
                                            <NotificationsButton onClick={isConfirmPage ? handleConfirmPageClick : _openNotifications} />
                                        </div>
                                    )}
                                </MaxWidth>
                            </Toolbar>
                        </StyledAppBar>
                    </div>
                </Paper>
            </Header>
            {/*
                The 'notificationsOpen' switch is for a11y —
                we don't want anything to be tabbable behind a modal that's open
            */}
            {notificationsOpen && <div className={isEditProfile ? `${Classes.main} ${Classes.editProfile}` : `${Classes.main}`} />}
            {!notificationsOpen && <div className={isEditProfile ? `${Classes.main} ${Classes.editProfile}` : `${Classes.main}`}>

                {/* Portal for scroll sibling top */}
                <div
                    id={ELEMENT_IDS.scrollPortalIds.top}
                    className={`contentWrapper ${Classes.scrollPortalTop}`}
                />

                {/* Scroll container */}

                <ScrollContainer
                    id={ELEMENT_IDS.scrollContainer}
                >
                    {/* Portal for scroll padding top */}
                    <div
                        id={ELEMENT_IDS.scrollPortalPaddingIds.top}
                        style={styles.scrollPadding}
                        className='contentWrapper'
                    />

                    <MainInnerWrapper className={`${!isFullWidthRoute && 'contentWrapper'}`}>
                        <HiddenPageHeading
                            id='main-page-heading'
                            tabIndex={0}
                            aria-label={`${pageTitle} page`}
                        >
                            {pageTitle}
                        </HiddenPageHeading>
                        {children}
                    </MainInnerWrapper>

                    {/* Portal for scroll padding bottom */}
                    <div
                        id={ELEMENT_IDS.scrollPortalPaddingIds.bottom}
                        style={styles.scrollPadding}
                        className='contentWrapper'
                    />
                </ScrollContainer>

                {/* Portal for scroll sibling bottom */}
                <div
                    id={ELEMENT_IDS.scrollPortalIds.bottom}
                    className={`contentWrapper ${Classes.scrollPortalBottom}`}
                />
            </div>}
            {!modalOpen && (
                <AppFooterTabs
                    currentUser={currentUser}
                    location={location}
                    isCommunity={isCommunity}
                    currentSchool={currentSchool}
                    unreadOffersCount={unreadOffersCount}
                    hasOffers={hasOffers}
                    unreadResourcesCount={unreadResourcesCount}
                    hasResources={hasResources}
                    debug={debug}
                />
            )}

            <NotificationsDialog
                open={notificationsOpen}
                onRequestClose={closeNotifications}
            />
            {displayStatus && <div aria-live='assertive' style={{ visibility: 'hidden', height: 0 }}>
                {numUnreadNotifications} new notification(s).
            </div>}
            <Snackbar style={styles.snackbar} />
            <SimpleDialog
                isOpen={isReviewDialogOpen}
                onRequestClose={closeReviewDialog}
                title='Rate Nearpeer'
                content='Enjoying our app? Please rate us in the app store!'
                buttons={
                    <>
                        <Button
                            onClick={closeReviewDialog}
                            color='primary'
                            variant='contained'
                            data-focus-outline='radius:40,padding:3'
                        >
                            Cancel
                        </Button>
                        <Button
                            style={{ marginLeft: 8 }}
                            onClick={confirmLeaveReview}
                            color='secondary'
                            variant='contained'
                            data-focus-outline='radius:40,padding:3'
                        >
                            Rate App
                        </Button>
                    </>
                }
            />
            <SimpleDialog
                isOpen={isNearpeerSwitcherDialogOpen}
                onConfirm={() => switchSchool({ id: 1 })}
                onRequestClose={() => setIsNearpeerSwitcherDialogOpen(false)}
                title='Switch Community?'
                content={(
                    <div
                        style={{
                            display: 'flex',
                            flexFlow: 'column nowrap',
                            alignItems: 'center',
                            width: isMobile ? 'auto' : '421px'
                        }}>
                        <div
                            style={{
                                display: 'flex',
                                flexFlow: 'row nowrap',
                                alignItems: 'center',
                                gap: 16,
                                marginBottom: 20
                            }}>
                            <img
                                src={currentSchoolSvgSrc}
                                style={{ height: DIALOG_SCHOOL_IMG_HEIGHT, maxWidth: 100 }}
                                alt={currentSchool.name}
                            />
                            <ArrowRightAltIcon
                                style={{
                                    fontSize: 52
                                }}
                            />
                            <img
                                src={nearpeerSvgSrc}
                                style={{ height: DIALOG_SCHOOL_IMG_HEIGHT, maxWidth: 100 }}
                                alt="Nearpeer"
                            />
                        </div>
                        <Typography
                            style={{
                                marginTop: 20
                            }}
                        >
                            Are you sure you want to switch from {currentSchool.name} to Nearpeer?
                        </Typography>
                    </div>
                )}
                buttons={(
                    <div style={{ display: 'flex', flexFlow: 'row nowrap', gap: 10 }}>
                        <Button
                            onClick={() => setIsNearpeerSwitcherDialogOpen(false)}
                            color='secondary'
                            variant='contained'
                            data-focus-outline='radius:40'
                        >
                            No
                        </Button>
                        <Button
                            onClick={() => switchSchool({ id: 1 })}
                            color='primary'
                            variant='contained'
                            data-focus-outline='radius:40'
                            autoFocus
                        >
                            Yes
                        </Button>
                    </div>
                )}
            />
            <SimpleDialog
                isOpen={isConfirmProfileDialogOpen}
                onRequestClose={closeConfirmProfileDialog}
                title='Please confirm your profile.'
                buttons={(
                    <Button
                        onClick={closeConfirmProfileDialog}
                        color='primary'
                        variant='contained'
                        data-focus-outline='radius:40'
                    >
                        Ok
                    </Button>
                )}
            />
            <FocusIndicator />
            <DowntimeDialog />
            <ForceAppUpgradeDialog />
        </Wrapper>
        </WeeklyLeaders>
    );
};

module.exports.propTypes = {
    notificationsOpen: T.bool,
    openNotifications: T.func,
    otherCommunityUnreadCounts: T.object,
    unreadOffersCount: T.number,
    hasOffers: T.bool,
    isLoadingOffers: T.bool,
    unreadResourcesCount: T.number,
    hasResources: T.bool,
    isLoadingResources: T.bool,
    closeNotifications: T.func,
    openLogoutDialog: T.func,
    closeLogoutDialog: T.func,
    logoutDialogOpen: T.bool,
    modalOpen: T.bool,
    currentUser: T.object,
    currentSchool: T.object,
    rootSchool: T.object,
    canJoinNearpeerCommunity: T.bool,
    switchableCommunities: T.array,
    joinableCommunities: T.array,
    schoolSlug: T.string,
    appHeaderLogoUrl: T.any,
    hasResourcesPage: T.bool,
    resourcesUrl: T.string,
    numUnreadNotifications: T.number,
    onLogout: T.func.isRequired,
    children: T.node,
    isOffline: T.bool,
    isCommunity: T.bool,
    navigate: T.func.isRequired,
    rolePermissions: RolePermissions,
    role: T.shape({
        id: T.number,
        name: T.string,
        label: T.string,
        roleGroupId: T.number
    }),
    location: T.shape({
        pathname: T.string.isRequired
    }),
    rootLoading: T.bool,
    isSSOSchool: T.bool,
    path: T.string,
    fullWidthMobileRoutes: T.array,
    isReviewEnabled: T.bool,
    nearpeerSchool: T.object,
    debug: T.object,
    setDebug: T.func
};

internals.LogoutConfirmButton = function LogoutConfirmButton(props) {

    const { onClick } = props;

    const { logout } = useSsoAuth();

    return (
        <Button
            variant='contained'
            data-focus-outline='radius:40,padding:3'
            onClick={() => {

                logout();
                onClick();
            }}
        >
            Yes
        </Button>
    );
};

internals.LogoutConfirmButton.propTypes = {
    onClick: T.func.isRequired
};

internals.Wrapper = Styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-flow: column nowrap;
`;

internals.Header = Styled.div`
    width: 100%;
    height: ${MAIN_HEADER_HEIGHT}px;
    background-color: black;

    > div {
        height: ${MAIN_HEADER_HEIGHT}px;
        width: 100%;

        border-radius-top-left: 0 !important;
        border-radius-top-right: 0 !important;
        border-radius-bottom-left: 0 !important;
        border-radius-bottom-right: 0 !important;
    }

    .paper {
        display: flex;
        background-color: $darkBrandColor !important;
        color: $lightText !important;
        border-radius: 0 !important;
        transition: none !important;
        z-index: 4; // Above Snackbar and BottomButton

        border-radius-top-left: 0 !important;
        border-radius-top-right: 0 !important;
        border-radius-bottom-left: 0 !important;
        border-radius-bottom-right: 0 !important;

        > div {
            flex: 1;
            align-items: center;
        }
    }
`;

internals.StyledAppBar = Styled(AppBar)`
    width: 100%;
    height: ${MAIN_HEADER_HEIGHT}px;
    border-radius: 0;

    position: fixed;
    top: var(--safezonetop);

    > div {
        padding: 8px;
    }
`;

internals.WhiteMenuIcon = Styled(MenuIcon)`
    width: ${({ theme }) => theme.constants.iconSize}px;
    height: ${({ theme }) => theme.constants.iconSize}px;
    color: ${({ theme }) => theme.palette.primary.contrast};
`;

internals.MaxWidth = Styled.div`
    position: relative;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    width: 100%;
    max-width: 600px;
    margin: auto;
`;

internals.HeaderStart = Styled.div`display: flex; align-items: center; flex-shrink: 0;`;

internals.TitleArea = Styled('div', transient$Props)`
    // Reserve 96px on each side so the logo stays centered as controls change.
    // The N button is absolutely positioned, so flex sizing cannot reserve its space.
    position: absolute;
    left: 50%;
    top: 0;
    transform: translateX(-50%);
    width: calc(100% - 192px);
    height: 100%;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;
    font-family: ${Fonts.headerFont};
    font-weight: bold;
    pointer-events: none;

    > a {
        pointer-events: auto;
        max-width: 100%;
        min-width: 0;
    }
    h1 {
        font-size: 24px;
        margin: 0;
    }
`;

internals.LogoContainer = Styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 100%;

    img {
        max-width: ${({ $compactDefaultLogo }) => $compactDefaultLogo ? 'min(136px, 100%)' : 'min(180px, 100%)'};
        height: 40px;
        width: auto;
        object-fit: contain;
        object-position: center;
        ${({ $compactDefaultLogo }) => $compactDefaultLogo && 'transform: translateY(2px);'}
    }
`;

internals.LogoMark = Styled.img`
    margin-right: 7px;
    height: 20px;
`;

internals.Greeting = Styled.div`
    position: relative;
    left: 0px;
    top: 5px;
    font-size: 13px;
    font-weight: bold;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    width: 30%;
    @media (min-width: 600px) {
        position: absolute;
        left: 5px;
        top: unset;
    }
`;

internals.styles = {
    appContextWrapper: {
        padding: '12px 16px 0px'
    },
    scrollPadding: {
        width: '100%'
    },
    logomark: {
        height: 25
    },
    tab: {
        background: 'none'
    },
    snackbar: {
        zIndex: 3 // Below nav tabs and above BottomButton
    },
    menuDivider: {
        marginTop: 5,
        marginBottom: 8
    },
    greetingMenuItem: {
        fontWeight: 'bold',
        color: 'inherit'
    }
};

internals.SpinnerContainer = Styled.div`
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-contents: center;
    border-radius:16px;
    background-color:rgba(255,255,255,0.75);
    height: 10rem;
    width: 10rem;
`;

internals.StyledBackdrop = Styled(Backdrop)`
  && {
    z-index: 2000;
    background-color: rgba(0, 0, 0, 0.2);
  }
`;

internals.MainInnerWrapper = Styled.main.attrs({
    id: 'main-content',
    tabIndex: -1
})`
    width: 100%;
    margin: 0 auto;
    flex-grow: 1;
    background-color: white;
    position: relative;
`;

internals.HiddenPageHeading = Styled.h1`
    position: absolute;
    width: 1px;
    height: 1px;
    margin: -1px;
    padding: 0;
    overflow: hidden;
    clip: rect(0 0 0 0);
    white-space: nowrap;
    border: 0;
`;

internals.SkipToContentLink = Styled.a`
    position: absolute;
    top: 12px;
    left: 12px;
    z-index: 6;
    padding: 10px 14px;
    border-radius: 10px;
    background: white;
    color: ${({ theme }) => theme.palette.primary.main};
    font-weight: 700;
    text-decoration: none;
    box-shadow: 0 4px 18px rgba(0, 0, 0, 0.22);
    transform: translateY(-150%);
    transition: transform 120ms ease-out;

    &:focus,
    &:focus-visible {
        transform: translateY(0);
        outline: 3px solid ${({ theme }) => theme.palette.secondary.main};
        outline-offset: 2px;
    }
`;

internals.StyledIconButton = Styled(IconButton)`
    width: 52px;
    height: 52px;

    color: white;

    display: flex;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;

    svg {
        width: ${({ theme }) => theme.constants.iconSize}px;
        height: ${({ theme }) => theme.constants.iconSize}px;
    }

    &:focus-visible {
        background-color: rgba(255, 255, 255, 0.5);
    }
`;

internals.ScrollContainer = Styled.div`
    width: 100%;
    min-height: 0;         /* critical so it does not force parent to overflow */
    height: 100%;

    display: flex;
    flex-flow: column nowrap;
    overflow: hidden;      /* so inner scrollContainer is the scroller */
    position: relative;

    overflow-y: auto;
    overflow-y: overlay;
    overflow-x: hidden;
    background-color: $emptyBackground;

    @media screen and (min-width: 601px) {
        // padding-left: 8px;

        /* Styles for scrollbar track */
        &::-webkit-scrollbar {
            width: 8px;
            height: 0;
        }

        &::-webkit-scrollbar-track {
            background-color: #f1f1f1;
        }

        &::-webkit-scrollbar-thumb {
            background-color: #888;
            border-radius: 6px;
            cursor: pointer;

            &:hover {
                background-color: #555; /* Adjust the hover color based on your design */
            }
        }

        /* Firefox */
        scrollbar-color: #888 #f1f1f1;
        scrollbar-width: thin;

        /* Common styles for all browsers */
        scrollbar-face-color: #f1f1f1;
        scrollbar-highlight-color: #888;
        scrollbar-shadow-color: #555;
        scrollbar-arrow-color: #555;
    }
`;

internals.NearpeerNSwitchButtonWrapper = Styled.div`
    position: absolute;
    top: 0px;
    left: 53px;
    z-index: 9999;

    @media screen and (max-width: 600px) {
        left: 49px;
    }
`;

internals.ManageCommunitiesLinkWrapper = Styled.div`
    position: absolute;
    top: 0px;
    right: 50px;
    z-index: 9999;
`;

internals.StyledImportExportIcon = Styled(ImportExportIcon)`
    transform: rotate(90deg);
`;

internals.StyledUnreadMessagesBadge = Styled(UnreadMessagesBadge)`
    position: absolute;
    right: 4px;
    top: 8px;
`;

internals.StyledAppMenu = Styled(MuiAppMenu)``;
